import React from 'react';
import {Box, Typography, Stack} from '@mui/material';
import {Button, Icon} from '@lightricks/react-design-system';
import type {ExperimentOverride} from '@/stores/modestExperimentOverrideStore';
import styles from './DeveloperOverrideModal.module.scss';
import EmptyState from './EmptyState';

interface CurrentOverridesSectionProps {
  testID?: string;
  currentOverrides: ExperimentOverride[];
  onRemoveOverride: (groupName: string) => void;
  onClearAll: () => void;
}

function CurrentOverridesSection({
  testID = 'current-overrides-section',
  currentOverrides,
  onRemoveOverride,
  onClearAll,
}: CurrentOverridesSectionProps) {
  return (
    <Box className={styles.currentOverridesSection} data-testid={testID}>
      <Box className={styles.currentOverridesHeader}>
        <Typography variant="h6" className={styles.sectionTitle}>
          Current Overrides
        </Typography>
        {currentOverrides.length > 0 && (
          <Button
            size="small"
            appearance="neutral"
            mode="plain"
            onClick={onClearAll}
          >
            Clear all
          </Button>
        )}
      </Box>

      {currentOverrides.length === 0 ? (
        <EmptyState
          icon="Actions-Info-Line"
          title="No overrides set"
          subtitle="Add experiment overrides to see them here"
        />
      ) : (
        <Stack direction="column" gap="8px">
          {currentOverrides.map((override) => (
            <Box key={override.groupName} className={styles.overrideItem}>
              <Typography variant="body2" className={styles.overrideItemText}>
                {override.groupName}: {override.variantDisplayName} (
                {override.variantName})
              </Typography>
              <Button
                size="small"
                appearance="neutral"
                mode="plain"
                onClick={() => onRemoveOverride(override.groupName)}
                className={styles.removeButton}
                icon={
                  <Icon
                    size="small"
                    appearance="neutral"
                    name="Actions-Remove"
                  />
                }
              />
            </Box>
          ))}
        </Stack>
      )}
    </Box>
  );
}

export default CurrentOverridesSection;
